<template>
  <span>
    <span v-html="ressource" v-if="ressource"></span>
    <span v-else-if="!hideIfEmpty">[{{ code }}]</span>
  </span>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: {
    code: String,
    hideIfEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["ressources"]),
    ressource() {
      if (this.ressources?.has(this.code)) {
        return this.ressources.get(this.code)
      }
      return ""
    }
  }
}
</script>

<style>
</style>